export default __webpack_public_path__ + "locales/tr/Profile.json?hash=9624f42d62a64cb3548f1ff82e8b966b";